import React from 'react';
import { Text, TextProps } from '@chakra-ui/react';
import { useAnimatedText } from '../../hooks/useAnimatedText';
import './AnimatedText.css';

interface AnimatedTextProps extends Omit<TextProps, 'children'> {
  texts: string[];
  interval?: number;
  loop?: boolean;
  className?: string;
}

function AnimatedText({ texts, interval = 2000, loop = true, className = '', ...textProps }: AnimatedTextProps) {
  const { currentText, isAnimating } = useAnimatedText({
    texts,
    interval,
    loop,
  });

  return (
    <Text className={`animated-text ${isAnimating ? 'fade-out' : 'fade-in'} ${className}`} {...textProps}>
      {currentText}
    </Text>
  );
}

export { AnimatedText };
